/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CartDto } from './CartDto';
import {
    CartDtoFromJSON,
    CartDtoFromJSONTyped,
    CartDtoToJSON,
} from './CartDto';

/**
 * 
 * @export
 * @interface SubmittedDigitalBillDto
 */
export interface SubmittedDigitalBillDto {
    /**
     * 
     * @type {string}
     * @memberof SubmittedDigitalBillDto
     */
    reference: string;
    /**
     * 
     * @type {CartDto}
     * @memberof SubmittedDigitalBillDto
     */
    cartDto?: CartDto;
}

/**
 * Check if a given object implements the SubmittedDigitalBillDto interface.
 */
export function instanceOfSubmittedDigitalBillDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "reference" in value;

    return isInstance;
}

export function SubmittedDigitalBillDtoFromJSON(json: any): SubmittedDigitalBillDto {
    return SubmittedDigitalBillDtoFromJSONTyped(json, false);
}

export function SubmittedDigitalBillDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmittedDigitalBillDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reference': json['reference'],
        'cartDto': !exists(json, 'cartDto') ? undefined : CartDtoFromJSON(json['cartDto']),
    };
}

export function SubmittedDigitalBillDtoToJSON(value?: SubmittedDigitalBillDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reference': value.reference,
        'cartDto': CartDtoToJSON(value.cartDto),
    };
}

